export const USAGE_EVENTS = [
  'sample-opened',
  'analysis-completed-upload',
  'analysis-empty-upload',
  'analysis-failed-upload',
  'packet-requested-upload-n8n',
  'packet-requested-upload-make',
  'packet-requested-upload-zapier',
  'packet-requested-sample-n8n',
  'packet-requested-sample-make',
  'packet-requested-sample-zapier',
  'consultation-click-general',
  'consultation-click-upload',
  'consultation-click-sample',
  'kit-checkout-click',
  'support-checkout-click',
  'kit-preview-requested',
  'guide-n8n-start',
  'guide-make-start',
  'guide-zapier-start',
  'guide-shutdown-start',
] as const;

export type UsageEvent = typeof USAGE_EVENTS[number];
export const PUBLIC_ORIGIN = 'https://relayrescue.app';
export const EXCLUSION_KEY = 'relay-rescue.exclude-measurement';

export function isUsageEvent(value: string): value is UsageEvent {
  return USAGE_EVENTS.some((event) => event === value);
}

export function measurementAllowed(origin: string, excluded: boolean, privacySignal: boolean): boolean {
  return origin === PUBLIC_ORIGIN && !excluded && !privacySignal;
}
